// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import LotteryItemBase from "../common/LotteryItemBase";
import { GoldFlowerKind } from "./data/GoldFlowerKind";

const {ccclass, property} = cc._decorator;


const c_cardColor = [
    {
        range: [2, 10],
        color: cc.color(0x01, 0x79, 0xff),
    },
    {
        range: [11, 13],
        color: cc.color(0x00, 0xAC, 0x55),
    },
    {
        range: [14, 14],
        color: cc.color(0xff, 0x00, 0x00),
    },
];

@ccclass
export default class GoldFlowerItemBase extends LotteryItemBase {


    @property([cc.Node])
    nodeItem: cc.Node[] = [];
    @property(cc.Label)
    labelCardType: cc.Label = null;
   
    private cardData: number[] = [];
    private cardType: number = 0;
    // onLoad () {}

    start () {
        this.initUI();
    }

    setData(
        cardData: number[]
        , cardType: number
    ) {
        this.cardData = cardData;
        this.cardType = cardType;
    }

    initUI() {
        this.cardData.sort((a,b)=> b-a);
        let cardTypeInfo = GoldFlowerKind.CardTypeInfoArr[this.cardType];
        if (this.cardType == GoldFlowerKind.CardType.YI_ZHANG) {
            
            let card = this.cardData[0];
            let idx = card - GoldFlowerKind.GeneralValue.SpaceValue;
            this.labelCardType.string = '单' + GoldFlowerKind.CardData[idx];
        } else {
            this.labelCardType.string = cardTypeInfo.name;
        }
        
        

        for (let i = 0; i < this.nodeItem.length; i++) {
            let nodeItem = this.nodeItem[i];
            let labelCard = nodeItem.getChildByName('labelCard').getComponent(cc.Label);
            let card = this.cardData[i];
            let idx = card - GoldFlowerKind.GeneralValue.SpaceValue;
            labelCard.string = GoldFlowerKind.CardData[idx] + '';

            // for (let o of c_cardColor) {
            //     if (card >= o.range[0] && card <= o.range[1]) {
            //         labelCard.node.color = o.color;
            //         break;
            //     }
            // }
        }
    }
    // update (dt) {}
}
